import { AdvancedTQLFilterDTO } from '@/entities/srm/tql-query/@x/dashboard-widget';
import { z } from 'zod/v4';
import { TimeRangeDTO } from '@/shared/lib/utils/date-time/time-range';

const LayoutItemDTO = z.object({
  i: z.string(),
  x: z.number(),
  y: z.number(),
  w: z.number(),
  h: z.number(),
  minW: z.number().optional(),
  minH: z.number().optional(),
  static: z.boolean().optional(),
});
const LayoutDTO = z.array(LayoutItemDTO);

export const TemplateGridDTO = z.object({
  id: z.string(),
  layout: LayoutItemDTO,
  nestedLayouts: z
    .record(z.string(), z.array(z.lazy(() => TemplateGridDTO)))
    .optional(),
});
export type TemplateGrid = z.infer<typeof TemplateGridDTO>;

export const FilterDTO = z.object({
  filter_id: z.string().nullish(),
  cis: z.array(z.string()),
});
export type Filter = z.infer<typeof FilterDTO>;

// Custom validation for FiltersDTO
export const FiltersDTO = z.object({
  data: z.array(FilterDTO),
  // .refine((arr) => arr.every((x) => x.filter_id !== null), {
  //   message: 'Bad data',
  // }),
});
export type Filters = z.infer<typeof FiltersDTO>;

export const TemplateDTO = z.object({
  grid: z.array(TemplateGridDTO).nullish(),
  interval: z.number().nullish(),
  filter: AdvancedTQLFilterDTO.nullish(),
  range: TimeRangeDTO,
});
export type Template = z.infer<typeof TemplateDTO>;

export const DashboardTemplateGridDTO = z.object({
  id: z.string(),
  layout: LayoutDTO,
  widgetId: z.string(),
});
export type DashboardTemplateGrid = z.infer<typeof DashboardTemplateGridDTO>;

export const DashboardTemplateDTO = z.object({
  grid: z.array(DashboardTemplateGridDTO),
  interval: z.tuple([z.string(), z.string()]),
  refresh: z.number(),
  isTemplate: z.boolean().nullish(),
  params: z.any().nullish(),
});
export type DashboardTemplate = z.infer<typeof DashboardTemplateDTO>;

//   CIT: z.array(z.string()),
//   widgetName: z.string(),
//   title: z.string(),
//   config: z.record(z.string(), z.any()).nullish(),
// });
// export type WidgetTemplate = z.infer<typeof WidgetTemplateDTO>;